import React, { useState } from "react";
import "./Style.css";

function Gallery() {

  const images = [
    "/Images/g1.jpeg",
    "/Images/g2.jpeg",
    "/Images/g3.jpeg",
    "/Images/g4.jpeg",
    "/Images/g5.jpeg",
    "/Images/g6.jpeg",
    "/Images/g7.jpeg",
    "/Images/g8.jpeg",
    "/Images/g9.jpeg",
    "/Images/g10.jpeg",
    "/Images/g11.jpeg",
    "/Images/g12.jpeg",
    "/Images/g13.jpeg",
    "/Images/g14.jpeg",
    "/Images/g15.jpeg",
    "/Images/g16.jpeg",
    "/Images/g17.jpeg",
    "/Images/g18.jpeg",
    "/Images/g19.jpeg",
    "/Images/g20.jpeg",
    "/Images/g21.jpeg",
    "/Images/g22.jpeg",
    "/Images/g23.jpeg",
    "/Images/g24.jpeg",
    "/Images/g25.jpeg"
    
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="gallery-page">

      <h2 className="gallery-title">Our Project Gallery</h2>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt="gallery"
            onClick={() => setSelectedImage(img)}
          />
        ))}
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="full" className="modal-img" />
        </div>
      )}

      {/* Document Section */}
      <div className="document-section">
        <h3>Project Document</h3>
        <a href="/Images/DOC-20180416-WA0049-2.pdf" target="_blank" rel="noreferrer">
          View Document
        </a>
      </div>

    </div>
  );
}

export default Gallery;